// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface NavRightDoubleIconSignature {
  Element: SVGSVGElement;
}

export const NavRightDoubleIcon: TOC<NavRightDoubleIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M5.586 19L7 20.415L15.414 12L7 3.586L5.586 5L12.586 12L5.586 19ZM10.586 19L12 20.415L20.414 12L12 3.586L10.586 5L17.586 12L10.586 19Z"/>
</svg>
</template>;